import { render, staticRenderFns } from "./ExpirationInput.vue?vue&type=template&id=fb33f988&scoped=true"
import script from "./ExpirationInput.vue?vue&type=script&lang=js"
export * from "./ExpirationInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb33f988",
  null
  
)

export default component.exports